// Quick Add Modal ko observe karne ka function
function observeQuickAddModal() {
    const quickModals = document.querySelectorAll('.quick-add-modal');

    quickModals.forEach(modal => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                // Jab modal ka 'open' attribute change ho
                if (mutation.attributeName === "open") {
                    const isOpen = modal.hasAttribute("open");
                    if (isOpen) {
                     
                        updatequick(modal); // Modal open hone ke baad updatequick() trigger karega
                    }
                }
            });
        });

        observer.observe(modal, { attributes: true });
    });
}

// Document ready hone par observer ko start karein
document.addEventListener("DOMContentLoaded", () => {
    observeQuickAddModal(); // Modal observer ko start karte hain
});


// Wait for iframe to be in the DOM before applying onload
const waitForIframe = setInterval(() => {
  const iframe = document.getElementById('aioWriteAReview');

  if (iframe) {
   

    iframe.onload = function () {
    

      try {
        const heading = iframe.contentWindow.document.querySelector('.rvw_heading');

        if (heading) {
         
          // heading.style.display = 'none';
          heading.style.fontFamily = 'Montserrat, sans-serif';
          heading.style.fontWeight = '600';
           heading.style.fontSize = '24px';
        } else {
        
        }
      } catch (err) {
    
      }
    };

    clearInterval(waitForIframe); // stop checking once iframe is found
  } else {
   
  }
}, 300); // check every 300ms



// inser country and birthday ready only


function applyProfileCustomizations() {
  const birthdayInput = document.querySelector('input[name="lyt_cus_birthday"]');
  const updateBtn = document.querySelector('#updateProfile');

  if (birthdayInput) {


    // Agar page load pe hi value hai toh disable karo
    if (birthdayInput.value && !birthdayInput.dataset.userEdited) {
 
      disableBirthday(birthdayInput);
    } else {

    }

    // Agar user new value dale toh editable rehna chahiye
    birthdayInput.addEventListener('change', () => {
  
      birthdayInput.disabled = false;
      birthdayInput.style.backgroundColor = '';
      birthdayInput.dataset.userEdited = "true";
    });

    // Update button click hone par dobara disable karo
    if (updateBtn) {
      updateBtn.addEventListener('click', () => {
       
        setTimeout(() => {
          if (birthdayInput.value) {
       
            disableBirthday(birthdayInput);
          }
        }, 500);
      });
    }
  }

  // ✅ Country field injection (same as before)
  const labels = document.querySelectorAll('.aio-form-label');
  let mobileGroup;

  labels.forEach(label => {
    if (label.textContent.trim() === 'Mobile') {
      mobileGroup = label.closest('.aio-form-group');
    }
  });

  if (mobileGroup && window.customerCountry) {
    const mobileContainer = mobileGroup.closest('.aio-sm-col-6.aio-col-12');

    if (mobileContainer && !document.querySelector('.country-field')) {
  
      const wrapperDiv = document.createElement('div');
      wrapperDiv.className = 'aio-sm-col-6 aio-col-12';

      const countryDiv = document.createElement('div');
      countryDiv.className = 'aio-form-group aio-full-width country-field';
      countryDiv.innerHTML = `
        <label class="aio-form-label">Country</label>
        <input name="country" id="country" type="text" 
          class="aio-form-control aio-text-capitalize" 
          value="${window.customerCountry}" disabled>
      `;

      wrapperDiv.appendChild(countryDiv);
      mobileContainer.parentNode.insertBefore(wrapperDiv, mobileContainer.nextSibling);
    } else {
   
    }
  }
}

function disableBirthday(birthdayInput) {
  birthdayInput.disabled = true;
  birthdayInput.style.backgroundColor = '#f9f9f9';

  if (!document.querySelector('#hiddenBirthday')) {

    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = birthdayInput.name;
    hidden.value = birthdayInput.value;
    hidden.id = 'hiddenBirthday';
    birthdayInput.parentNode.appendChild(hidden);
  } else {

    document.querySelector('#hiddenBirthday').value = birthdayInput.value;
  }
}

// MutationObserver
const observer = new MutationObserver(() => {

  applyProfileCustomizations();
});
observer.observe(document.body, { childList: true, subtree: true });

// First run
document.addEventListener('DOMContentLoaded', () => {

  applyProfileCustomizations();

  // Extra fallback checks
  setTimeout(() => {
  
    applyProfileCustomizations();
  }, 1000);
  setTimeout(() => {

    applyProfileCustomizations();
  }, 3000);
});



// js for css on iframe chat icon......


function injectCSSIntoIframe() {
  const iframe = document.getElementById("allinoneiframchat");
  if (!iframe) {

    setTimeout(injectCSSIntoIframe, 500);
    return;
  }

  // Try accessing the iframe's document
  try {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    const style = iframeDoc.createElement("style");
    style.textContent = `
      .aitrillion-chat-icon-only {
        min-height: 50px !important;
        width: 40px !important;
        height: 40px !important;
       
      }

      .panda-pop-open {
        width: 40px !important;
      }
    `;

    iframeDoc.head.appendChild(style);
  
  } catch (e) {
   
  }
}

window.addEventListener("load", injectCSSIntoIframe);




// js to make input field ready only loyalty popup

(function () {
  const LOG = '[AIO-READONLY]';
  const OVERLAY_SELECTORS = [
    '.aaa-loyalty-overlay.aio-loyalty-login',
    '.aaa-loyalty-overlay',
    '.aio-loyalty-popup',
    '.aio_popup_container'
  ];
  
  // 🎯 Match ONLY the Earn Points DOB field — not other birthday fields
  const INPUT_SELECTOR = 'input.aio_loyalty_birth_date.loyalty_birth_date_new[name="birth_date"]';
  const TAB_CLICK_SELECTOR = '.earn-point-tab, .list-group-item';
  
  const handled = new WeakMap();
  const log = (...args) => console.log(LOG, ...args);

function applyReadonlyToInputs(scope) {
  const root = scope || document;
  const inputs = Array.from(root.querySelectorAll(INPUT_SELECTOR));
  if (!inputs.length) return false;

  let applied = false;

  inputs.forEach(input => {
    // ✅ Only proceed if input has a value
    if (input.value && !input.hasAttribute('readonly')) {
      input.setAttribute('readonly', '');
      log('✅ Applied readonly to Earn Points DOB input', input);
      applied = true;

      // Prevent calendar popup on iOS
      if (!input._aio_focusHandlerAdded) {
        input.addEventListener('focus', function (e) {
          e.preventDefault();
          this.blur();
        });
        input._aio_focusHandlerAdded = true;
        log('📌 Focus blur handler added');
      }

      // ✅ Apply pointer blocking only when readonly is added
      input.style.pointerEvents = "none";
      input.style.backgroundColor = "#f9f9f9";
    }
  });

  return applied;
}


  function handleOverlay(overlay) {
    if (!overlay || handled.has(overlay)) return;
    log('🔍 Handling overlay:', overlay);

    applyReadonlyToInputs(overlay);

    const overlayObserver = new MutationObserver(() => applyReadonlyToInputs(overlay));
    overlayObserver.observe(overlay, { childList: true, subtree: true });

    const clickHandler = (e) => {
      if (e.target.closest && e.target.closest(TAB_CLICK_SELECTOR)) {
        setTimeout(() => applyReadonlyToInputs(overlay), 120);
      }
    };
    overlay.addEventListener('click', clickHandler);

    const attrObserver = new MutationObserver(() => {
      if (overlay.classList.contains('open') || isVisible(overlay)) {
        setTimeout(() => applyReadonlyToInputs(overlay), 120);
      }
    });
    attrObserver.observe(overlay, { attributes: true, attributeFilter: ['class'] });

    handled.set(overlay, { overlayObserver, clickHandler, attrObserver });
  }

  function isVisible(el) {
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  const bodyObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          const overlay = OVERLAY_SELECTORS.some(s => node.matches(s)) ? node : node.querySelector(OVERLAY_SELECTORS.join(','));
          if (overlay) handleOverlay(overlay);
        }
      }
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => {
    OVERLAY_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(o => handleOverlay(o));
    });
    applyReadonlyToInputs(document);
  });

  log('🚀 Readonly injection script initialized');
})();




// js to add account tab on loyalty popup

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const helpTab = document.querySelector(".list-group-item.help_tab");

    if (helpTab) {


      // Agar account tab already add na hua ho
      if (!document.querySelector(".list-group-item.account_tab")) {
        // Account tab ka HTML with direct href
        const accountHTML = `
          <div style="background-color:#ffedf1;" 
               class="list-group-item account_tab" 
               title="account" 
               data-currency="$">
            <a href="https://prettyfit.com.sg/account" target="_self">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" style="vertical-align: sub;">
                  <g transform="translate(-116 -324)">
                    <path d="M350.469,515a2.846,2.846,0,0,1-2.156-1.01v-9.7l7.015-4.991a1.4,1.4,0,0,1,2.012.233,1.442,1.442,0,0,1-.229,2.039l-2.2,1.773h10.651a1.457,1.457,0,0,1,0,2.913h-6.468a1.457,1.457,0,0,1,0,2.913h-.719a1.457,1.457,0,0,1,0,2.914h-.718a1.457,1.457,0,0,1,0,2.913Zm-5.75,0a.686.686,0,0,1-.719-.647V503.994a.686.686,0,0,1,.719-.648h1.437a.686.686,0,0,1,.719.646v10.36a.686.686,0,0,1-.719.648Z" transform="translate(-228 -172)"></path>
                    <rect width="23" height="23" transform="translate(116 324)" fill="none" opacity="0.5"></rect>
                  </g>
                </svg>
              </i>
              Account
            </a>
          </div>
        `;

        // Help tab ke baad insert kare
        helpTab.insertAdjacentHTML("afterend", accountHTML);


      }

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});




// aaa js for changes on my account ******


document.addEventListener('DOMContentLoaded', function() {

  function updateBrowseButton() {
    const activeMenu = document.querySelector('.aio-menu-productreview.aio-menu-active');
    const browseBtn = document.querySelector('.aio-browse-btn');

    if (browseBtn) {
      if (activeMenu) {
        browseBtn.setAttribute('href', '#/myorders');
   
      } else {
        browseBtn.setAttribute('href', '/collections/all');

      }
    }
  }

  // Observe the account app for changes
  const target = document.getElementById('aio-my-account-app');
  if (target) {
    const observer = new MutationObserver(updateBrowseButton);
    observer.observe(target, { childList: true, subtree: true });
  }

  // Also run every 500ms just to be safe
  setInterval(updateBrowseButton, 500);
});



// js for change link leave a reiew in popup


// Function to update review button links inside popup
function updatePopupReviewLinks() {
    const popup = document.getElementById('popup1');
    if (!popup) return;

    // Find all .aio_achived_btn inside the popup
    const reviewBtns = popup.querySelectorAll('.aio_achived_btn');
    reviewBtns.forEach(btn => {
        btn.href = "https://prettyfit.com.sg/account#/myorders";
      
    });
}

// Check if Earn Points tab is active
function checkActiveTab() {
    const tabContainer = document.querySelector('.kp_parent_div.balancepoints');
    if (!tabContainer) return;

    const activeTab = tabContainer.querySelector('.list-group-item.earn-point-tab.active');
    if (activeTab) {
       
        updatePopupReviewLinks();
    }
}

// Observe the document for popup injection
const bodyObserver = new MutationObserver(() => {
    const popup = document.getElementById('popup1');
    if (popup) {
   

        const popupObserver = new MutationObserver(() => {
            checkActiveTab();
        });

        popupObserver.observe(popup, { childList: true, subtree: true });
        bodyObserver.disconnect(); // Stop observing body
    }
});

bodyObserver.observe(document.body, { childList: true, subtree: true });

// Also attach click listener on Earn points tab
document.addEventListener('click', (e) => {
    const clickedTab = e.target.closest('.list-group-item.earn-point-tab');
    if (clickedTab) {
        // Wait a bit for dynamic content to inject
        setTimeout(() => {
            checkActiveTab();
        }, 100);
    }
});

